// Native
import { useState } from "react"
import { Button, HStack, Stack, Text } from "@chakra-ui/react"

// Custom
import { Form, UI } from "components"
import { API, toaster } from "config"
import useUser from "hooks/useUser"

export default function Password(){

    const user = useUser()

    const [ password, setPassword ] = useState()
    const [ new_password, setNewPassword ] = useState()
    const [ new_password_confirmation, setPasswordRetype ] = useState()
    const [ loading, setLoading ] = useState(false)
    const [ errors, setErrors ] = useState()

    const handleSubmit = async () => {
        setLoading(true)
        setErrors(false)

        // Verifica se as novas senhas coincidem
        if (new_password !== new_password_confirmation) {
            setErrors({
                new_password_retype: "As senhas não coincidem.",
            })
            toaster.create({
                title: "Senhas diferentes",
                description: "A nova senha e a confirmação precisam ser iguais.",
                type: "warning",
            })
            setLoading(false)
            return
        }

        try {
            await API.put("/me", { password, new_password, new_password_confirmation })
            toaster.create({ title: "Sua senha foi alterada!", type: "success" })
            user.refetch()
            setPassword(null)
            setPasswordRetype(null)
        } catch (err) {
            setErrors(err.response.data?.message)
            toaster.create({
                title: "Não foi possível atualizar. Tente novamente.",
                description: err?.response?.data?.message,
                type: "warning",
            })
        }

        setLoading(false)
    }

    return(
    <UI.Box loading={user.isLoading} h="auto">
        <Text children="Alterar senha:" size="xs" color="GrayText" mb={4} />

        <Stack gap={4}>

            <Form.Password 
                required
                label="Senha atual:"
                value={password}
                onChange={e => setPassword(e.target.value)}
                error={errors?.password}
                disabled={loading}
                helper="Insira a senha atual para alterar a senha."
                variant="ghost"
            />

            <HStack alignItems="flex-start" gap={4}>

                <Form.Password 
                    required
                    label="Nova senha:"
                    value={new_password}
                    onChange={e => setNewPassword(e.target.value)}
                    error={errors?.new_password}
                    disabled={loading}
                    variant="ghost"
                />

                <Form.Password 
                    required
                    label="Repita a senha:"
                    value={new_password_confirmation}
                    onChange={e => setPasswordRetype(e.target.value)}
                    error={errors?.new_password_confirmation}
                    disabled={loading}
                    variant="ghost"
                />

            </HStack>

            <UI.Show visible={!!new_password}>
                <Button colorPalette="orange" loading={loading} onClick={handleSubmit}><UI.Icon name="password" /> Alterar senha</Button>
            </UI.Show>

        </Stack>
    </UI.Box>
    )
}